import { Component, DestroyRef, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { API } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { ChangelogService } from 'src/app/services/gui/changelog/changelog.service';
import { ModalService } from 'src/app/services/gui/modal/modal.service';
import { NavpointsService } from 'src/app/services/navpoints.service';
import { UserService } from 'src/app/services/user.service';
import { UtilService } from 'src/app/services/util.service';
import { SbNavpointModel } from '@ngx-seatback/layout';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
  selector: 'sb-page-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.scss'],
  standalone: false,
})
export class AdminHomeComponent implements OnInit {
  loading: boolean;
  locked: boolean;

  form: UntypedFormGroup;

  constructor(
    public readonly navpointsService: NavpointsService,
    private readonly api: API,
    private readonly destroyRef: DestroyRef,
    public readonly modal: ModalService,
    public readonly userStatus: UserService,
    private readonly changelogService: ChangelogService,
    public readonly errorHandler: ErrorService,
    public readonly util: UtilService,
    private readonly authService: AuthenticationService
  ) {
    this.loading = true;
    this.locked = true;
    this.form = new UntypedFormGroup({
      adminKey: new UntypedFormControl('', Validators.required),
    });
  }

  get adminKey() {
    return this.form.get('adminKey');
  }

  ngOnInit() {
    let data: Map<string, SbNavpointModel[]>;
    this.api
      ._admin_AdminEndpoints_uptime()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (uptime: number) => {
          if (uptime) {
            this.locked = false;
          }
          data = this.navpointsService.getAdminNavpoints(!!uptime);
          this.navpointsService.navMain = data.get('main');
          this.navpointsService.navFooter = data.get('footer');
          this.refreshKeyInput();
        },
        error: () => {
          this.refreshKeyInput();
        },
      });
  }

  refreshKeyInput() {
    if (!this.locked) {
      this.adminKey.disable();
    } else {
      this.adminKey.enable();
    }
  }

  toggleLock() {
    if (this.locked) {
      this.authService.clearAdminKey();
      this.authService.setAdminKey(this.adminKey.value);
      this.loading = true;
      this.api
        ._admin_AdminEndpoints_uptime()
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          take(1),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: (uptime: number) => {
            if (uptime) {
              this.locked = false;
            }
            this.reload();
          },
          error: error => {
            this.authService.clearAdminKey();
            this.errorHandler.errorHandler(error);
          },
        });
    } else {
      this.authService.clearAdminKey();
      this.locked = true;
      this.reload();
    }
  }

  reload() {
    window.location.href = '/admin';
  }

  getFrontendVersion(): string {
    return this.changelogService.getFrontendVersion();
  }

  getBackendVersion(): string {
    return this.changelogService.getBackendVersion();
  }

  getFrontendName() {
    return this.changelogService.getFrontendName();
  }

  getBackendName() {
    return this.changelogService.getBackendName();
  }

  showFrontendChangelog() {
    this.changelogService.showFrontendChangelog();
  }

  showBackendChangelog() {
    this.changelogService.showBackendChangelog();
  }
}
